import { getConfig } from '../configService';

export function getSlotThumbnailUrl(slot, providerId) {
    if (!slot?.thumbnailGuid || slot.thumbnailGuid === '00000000-0000-0000-0000-000000000000') {
        return undefined;
    }
    try {
        const config = getConfig();
        return `${config.imageBaseUrl}provider-thumbnails/${providerId}/${slot.thumbnailGuid}.jpg`;
    } catch (error) {
        console.error("Error building thumbnail URL:", error);
        return undefined;
    }
}
